import { render, staticRenderFns } from "./JGridIndexActions.vue?vue&type=template&id=7d07d46f&"
import script from "./JGridIndexActions.vue?vue&type=script&lang=js&"
export * from "./JGridIndexActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports